._About_1tles_1 ._description_1tles_1 {
  font-size: 16px;
  line-height: 24px;
}